import {useSelector} from "react-redux";
import {
    Button,
    Dialog,
    Grid,
    ListItem,
    ListItemText,
    Paper,
    Typography,
    IconButton,
    DialogContent,
    DialogActions,
    ListItemIcon,
} from "@mui/material";

import Web3 from "web3";
import consensus_abi from "../abis/consensus_abi.json";

import {useState} from "react";

import BoltIcon from '@mui/icons-material/Bolt';

import {toWei} from "../utils/format";
import CoineusLoading from "../components/CoineusLoading";
import TokenListItem from "../components/TokenListItem";
import {CoineusCryptoFormat, CoineusUSDFormat} from "../utils/currency_format";
import getUserBalances from "../utils/get_balances";
import CEUSONE from "../components/ONES/CEUSONE";
import LITAssetBacking from "../components/AssetBacking/LIT";
import VisibilityIcon from '@mui/icons-material/Visibility';
import HideSourceIcon from '@mui/icons-material/HideSource';
import {useDispatch} from "react-redux";
import {updateSettingVisibility, updateSettingZeroBalance} from "../redux/slices/coineusSlice";
import WFUSEDialog from "../components/WFUSEDialog";
import FVKSRGAssetBacking from "../components/AssetBacking/FVKSRG";
import Faucets from "./Faucets/Faucets";
import Staking from "./Staking";
import Stats from "./Stats";
import EarnDetails from "./EarnDetails";

export default function HomePage() {

    const dispatch = useDispatch();

    const {wallet, settings} = useSelector(state => state.coineus);

    const [pending, setPending] = useState(false);
    const [stakeOpen, setStakeOpen] = useState(false);

    const cols = {xs:12, md:6, lg:4};

    return (<Grid container spacing={2} style={{ paddingTop: 20, paddingBottom: 20}}>
            {/*<Grid item xs={12}>*/}
            {/*    <Paper style={{padding: 20, border: '1px solid #fbca00'}}>*/}
            {/*        <Typography color="primary" fontWeight={700}>New!</Typography>*/}
            {/*        <Typography>Stats page displaying Rewards, Supply, Coineus One Deposits, Burn and*/}
            {/*            more.</Typography>*/}
            {/*        <Link to="/stats" component={RouterLink} underline="hover">View Stats</Link>*/}
            {/*    </Paper>*/}
            {/*</Grid>*/}
            <Grid item {...cols}>
                <Typography variant='h6'>Wallet</Typography>
                <Paper style={{marginTop: 10}}>
                    <ListItem>
                        <ListItemIcon onClick={()=>dispatch(updateSettingVisibility())}>
                            <VisibilityIcon color={settings.visibility ? "disabled" : ""} />
                        </ListItemIcon>
                        <ListItemIcon onClick={()=>dispatch(updateSettingZeroBalance())}>
                            <HideSourceIcon color={settings.showZeroBalance ? "disabled" : ""}/>
                        </ListItemIcon>
                        <ListItemText
                            primary={settings.visibility ? CoineusUSDFormat(
                                wallet.totals.fuse
                            ) : '*****'}
                            secondary="Total Wallet Value"
                            primaryTypographyProps={{ fontSize: '1.5rem', textAlign: 'right'}}
                            secondaryTypographyProps={{textAlign: 'right'}}
                        />
                    </ListItem>
                </Paper>

                {/*FUSE*/}
                <TokenListItem
                    contract_address="native"
                    wrap="0x0BE9e53fd7EDaC9F859882AfdDa116645287C629"
                    network="fuse"
                    name="FUSE"
                    native
                    price={wallet.prices.fuse?.native}
                    pair="0x91520Fc2942Fd52949514f159aA4927b8850178d"
                    invertPrice={true}
                    secondaryAction={
                        <IconButton
                            disabled={wallet.chain !== 122}
                            edge="end"
                            aria-label="stake"
                            onClick={() => setStakeOpen(true)}
                            color="primary"
                        >
                            <BoltIcon/>
                        </IconButton>
                    }
                />
                <PowerStake
                    open={stakeOpen}
                    amount={wallet.balances.fuse.native}
                    close={() => setStakeOpen(false)}
                    onSubmit={() => {
                        setStakeOpen(false);
                        setPending(true);
                    }}
                    onSuccess={() => {
                        getUserBalances(wallet.address);
                        setPending(false);
                    }}
                    onError={(err) => {
                        setPending(false);
                    }}
                />

                {/*CEUS*/}
                <TokenListItem
                    contract_address="0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8"
                    network="fuse"
                    name="CEUS"
                    price={wallet.prices.fuse?.["0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8"]}
                    pair="0x3b46eFdd411cc0Db43f1BE7853727e18Cce8b85b"
                />

                {/*CEUSONE*/}
                <TokenListItem
                    contract_address="0xE27431FACb1F093BA164c9F86B3f484b39ad54CC"
                    network="fuse"
                    name="CEUSONE"
                    price={wallet.prices.fuse?.["0xE27431FACb1F093BA164c9F86B3f484b39ad54CC"]}
                    secondaryAction={<CEUSONE onSuccess={() => getUserBalances(wallet.address)}/>}
                    cnsDetails={wallet.info.fuse?.["0xE27431FACb1F093BA164c9F86B3f484b39ad54CC"]}
                    detailsLabel="CEUSONE"
                />

                {/*LIT*/}
                <TokenListItem
                    contract_address="0xF2C6C1AA2bf8ec40F564Ea8A483F64907ea37A3F"
                    network="fuse"
                    name="LIT"
                    price={wallet.prices.fuse?.["0xF2C6C1AA2bf8ec40F564Ea8A483F64907ea37A3F"]}
                    pair="0x1A77BAea67C346cE17486b078a3c3F53a99A9Fcc"
                    secondaryAction={<LITAssetBacking/>}
                />

                {/*FOO*/}
                <TokenListItem
                    contract_address="0x74616164eB1892ceC5fa553D45b3e5D6dF7BC7b9"
                    network="fuse"
                    name="$FOO"
                    price={wallet.prices.fuse?.["0x74616164eB1892ceC5fa553D45b3e5D6dF7BC7b9"]}
                    pair="0x4f47a2c360266230795CFBca80b7C89EdA52Cd52"
                />

                {/*FVKSRG*/}
                <TokenListItem
                    contract_address="0xa28a758619ba32B11F8D55eB6C0E1C7E5929bF61"
                    network="fuse"
                    name="FVKSRG"
                    price={wallet.prices.fuse?.["0xa28a758619ba32B11F8D55eB6C0E1C7E5929bF61"]}
                    pair="0xA9c312E6DAC0EC56C6A8CB338e9121c6349D9beD"
                    secondaryAction={<FVKSRGAssetBacking/>}
                />

                {/*WFUSE*/}
                <TokenListItem
                    contract_address="0x0BE9e53fd7EDaC9F859882AfdDa116645287C629"
                    network="fuse"
                    name="WFUSE"
                    price={wallet.prices.fuse?.["0x0BE9e53fd7EDaC9F859882AfdDa116645287C629"]}
                    secondaryAction={<WFUSEDialog onSuccess={() => getUserBalances(wallet.address)}/>}
                />
            </Grid>

            <Grid item {...cols}>
                <Typography variant='h6'>CEUS Staking</Typography>
                <EarnDetails contract_address='0xB79a7A790165B725E9A2ad0E65C4A816B5C0eC57' network='fuse' />
                <Typography variant='h6'>FUSE Staking</Typography>
                <Staking />
            </Grid>

            <Grid item {...cols}>
                <Typography variant='h6'>Stats</Typography>
                <Stats />
                <Typography variant='h6'>Faucet</Typography>
                <Faucets />
            </Grid>


            <Grid item {...cols}>
            </Grid>
            <CoineusLoading open={pending} label="Transaction Pending"/>
        </Grid>
    );
}

function PowerStake(props) {

    const {wallet} = useSelector(state => state.coineus);
    const {open, close, amount, onSubmit, onSuccess, onError} = props;

    const delegate = () => {

        if (!wallet.address) return;

        const web3 = new Web3(window.provider);
        const connectedContract = new web3.eth.Contract(consensus_abi, "0x3014ca10b91cb3D0AD85fEf7A3Cb95BCAc9c0f79")//fuse consensus address

        connectedContract.methods
            .delegate("0xb27feaab8e4f4423e0b9c6f743e26e23a5c0c1b3")//validator address
            .send({
                from: wallet.address,
                value: toWei(amount - .1),
                gasPrice: 12000000000
            })
            .once('transactionHash', function (tx) {
                onSubmit();
            })
            .on('error', function (error) {
                onError(error)
            })
            .then(function (receipt) {
                onSuccess()
            })
            .catch((error) => {
                onError(error)
            });
    }

    return <Dialog open={open} fullWidth maxWidth="sm">
        <DialogContent>
            <Typography>Stake <b>{CoineusCryptoFormat(amount - .1)}</b> FUSE</Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={close}>cancel</Button>
            <Button onClick={delegate} variant="contained">Stake</Button>
        </DialogActions>
    </Dialog>
}